export const getSessionInfo = function () {
	return fetch('/actions/users/session-info', {
		headers: {
			Accept: 'application/json'
		}
	}).then((response) => response.json())
}

/**
 * Wraps the elements of an array.
 * @param {Array} arr - the array of elements to be wrapped
 * @param {String} wrapType - the type of the wrap element ('div', 'span' etc)
 * @param {String} wrapClass - the wrap class(es)
 */

export const WrapLines = (arr, wrapType, wrapClass) => {
  arr.forEach((el) => {
    const wrapEl = document.createElement(wrapType)
    wrapEl.classList = wrapClass
    el.parentNode.appendChild(wrapEl)
    wrapEl.appendChild(el)
  })
}

export const isSafariBrowser = () => {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
}

export const isFirefoxBrowser = () => {
  return navigator.userAgent.toLowerCase().includes('firefox');
}

const blueLogoPaths = ['/insights', '/our-customers']

export const setHeaderColour = (container, urlPath) => {
	const path = (urlPath || window.location.pathname).replace(/\/$/, '')
	const hasBlueLogo = blueLogoPaths.some(
		p => path === p || path.startsWith(p + '/')
	)
	const theme = hasBlueLogo ? 'insights' : container.dataset.header
	document.documentElement.setAttribute('data-header-theme', theme)
}

export const refreshScripts = (container) => {
	const scripts = container.querySelectorAll('main script')
	scripts.forEach((script) => {
    eval(script.innerHTML) 
  })
}

export const closeHeaderDropdowns = () => {
	const header = document.querySelector('.header')
	const menuItems = header.querySelectorAll('.menu-item, .submenu-list .menu-item')
	const menuLinks = header.querySelectorAll('.menu-item a, .submenu-list .menu-item a')
	const menuSubmenus = header.querySelectorAll('.submenu')

	header.style.pointerEvents = 'none'
	header.classList.remove('submenu-open')

	menuItems.forEach((menuItem) => menuItem.style.pointerEvents = 'none')
	menuLinks.forEach((menuLink) => menuLink.blur())
	menuSubmenus.forEach((menuSubmenu) => menuSubmenu.style.pointerEvents = 'none')

	setTimeout(() => {
		header.style.pointerEvents = 'auto'
		menuItems.forEach((menuItem) => menuItem.style.pointerEvents = 'auto')
		menuLinks.forEach((menuLink) => menuLink.blur())
		menuSubmenus.forEach((menuSubmenu) => menuSubmenu.style.pointerEvents = 'auto')
	}, 500)
}

export const debounce = (func, delay) => {
  let timeoutId
  return function (...args) {
    if (timeoutId) {
      clearTimeout(timeoutId)
    }
    timeoutId = setTimeout(() => {
      func.apply(this, args)
    }, delay)
  }
}

export const autoplayVideos = (container) => {
  const videos = container.querySelectorAll('video[autoplay]')
  videos.forEach((video) => video.play())
}

export default () => {}
